import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { PackingSlipModel } from "../../../dailyPlanning/domain/models/packingSlipModel";
import { pdf } from "@react-pdf/renderer";
import { PackingSlipPdf } from "./PackingSlipPdf";

interface props {
  packingSlip: PackingSlipModel;
}

export const PackingSlipExportButton = ({ packingSlip }: props) => {
  const { t } = useTranslation("common");

  const handleClick = async () => {
    const blob = await pdf(
      <PackingSlipPdf packingSlips={[packingSlip]} />,
    ).toBlob();

    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  };

  return (
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    <Button variant={"primary"} className="btn-sm" onClick={handleClick}>
      {t("Download PDF")}
    </Button>
  );
};
